var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._g(_vm._b({ref:"GeneralPopup",staticClass:"gc-popup",attrs:{"id":"gc-popup"},on:{"shown":_vm.setupPopupmutationObservers,"hide":_vm.closePopup}},'b-modal',_vm.componentAttrs,false),_vm.componentListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }